// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"209d1e91","977":"001b8653"}[chunkId] + ".chunk.js";
};